import React, { useState, useEffect } from 'react';
import {
    Text, TextInput, View, Image, StyleSheet, ScrollView, TouchableOpacity
} from 'react-native';
import AppStyles from "../../AppStyles";
import AppTheme from "../../AppTheme";
import { applyAgeGenderFilter } from '../../utils/services/CommonUtils';
import * as Redux from '../../utils/services/redux/commonRedux';
import * as CommonUtils from "../../utils/services/CommonUtils";
import * as MoengageUtils from "../../utils/services/webapp-services/MoengageUtils";
import * as AlertService from "../../utils/services/AlertLoaderService";
import { CommonHeader } from "../../utils/widgets/CommonWidget/CommonHeader";
import { addFontFamilyStyle } from "../../utils/services/CommonUtils";
import { ScreenRoute } from '../../utils/constants/ScreenRouteConstant';
import { Categories } from '../../utils/constants/econsult/Category';
import TextStyle from '../../TextStyle';

const CategorySelection = (props) => {


    const [categoriesList, setCategoriesList] = useState([]);
    const [categoriesCarrierList, setCategoriesCarrierList] = useState([]);

    const [inputFocused, setInputFocused] = useState(false);

    const memberData = props.route.params?.consultationParams?.selectedMember ?? null

    const loadCategories = (age, gender) => {
        var list: any = [];
        for (const [, category] of Object.entries(Categories)) {
            if (applyAgeGenderFilter(age, gender, category)) {
                list.push(category);
            }
        }
        list.sort((category1, category2) => {
            if (category1.cm.en == 'Other Problems') {
                return 1
            }
            else if (category2.cm.en == 'Other Problems')
                return -1
            else return category1.cm.en.localeCompare(category2.cm.en)
        })
        setCategoriesList(list);
        setCategoriesCarrierList(list);
    }

    useEffect(() => {
        AlertService.loaderModal.setLoader(false)
        loadCategories(
            memberData.age ?? 20,
            memberData.gender ?? 'Male'
        );
    }, []);

    function searchFilter(input) {
        var categoryListCopy: any = [];
        var otherProblemData = {};
        var matchInput = false;
        console.log('###, search word', input)
        categoriesList.map((category: any) => {
            if (category.cm.en.toLowerCase().includes(input.toLowerCase())
                || category.friendlyName.toLowerCase().includes(input.toLowerCase())) {
                categoryListCopy.push(category);
                matchInput = true;
            }
            if (category.caseCode == "Miscellaneous")
                otherProblemData = category;
        })
        if (!matchInput) {
            categoryListCopy.push(otherProblemData);
        }
        setCategoriesCarrierList(categoryListCopy);
    }

    return (
        <View>
            <CommonHeader navigation={props.navigation} title='Choose Problem Category' />

            <View style={[AppStyles.topFix, AppStyles.bgWhite,
            { marginTop: AppTheme.headerHeight }]}>

                <View style={[AppStyles.flexRowCenter, { marginVertical: 16, marginHorizontal: 16 }]}>
                    <Image source={{
                        uri: CommonUtils.getMemberProfileURL(memberData),
                        width: 46, height: 46
                    }}
                        style={{ borderRadius: 50, borderWidth: 1, borderColor: AppTheme.color.lightGreyColor }}></Image>
                    <Text numberOfLines={1} style={{ fontSize: 16, marginLeft: 16, width: AppTheme.appWidth - 92 }}>{memberData.name}</Text>
                </View>

                <View style={[AppStyles.flexRowSpaceBetween,
                AppStyles.darkShadow,
                {
                    marginHorizontal: 16,
                    paddingVertical: 4,
                    paddingRight: 16,
                    borderRadius: 4,
                    borderColor: AppTheme.color.lightGreyColor
                }]}>
                    <TextInput
                        style={[styles.inputBox]}
                        onFocus={() => setInputFocused(true)}
                        onBlur={() => setInputFocused(false)}
                        placeholder="Type your problem here..."
                        onChangeText={text => { searchFilter(text) }}
                        placeholderTextColor={AppTheme.color.lightGreyColor} />
                    {/* <MaterialIcons name="search" size={24} color={AppTheme.color.lightGreyColor} /> */}
                    <Image source={{
                        uri: CommonUtils.getImagePath(
                            '/images/icons/search_grey.svg'),
                        width: 18,
                        height: 18
                    }} />

                </View>

                <Text style={[TextStyle.text16b,
                {
                    paddingBottom: 16,
                    paddingTop: 8,
                    marginHorizontal: 16
                }]}>
                    or select from these categories</Text>
            </View>

            <ScrollView style={{
                backgroundColor: '#ffffff', width: AppTheme.appWidth - 16,
                zIndex: 1, margin: 'auto', marginLeft: 8, marginTop: 200
            }}>
                <View style={[styles.flexContainer, { marginBottom: 16, marginTop: 27 }]}>
                    {
                        categoriesCarrierList.map((caseObject: any, index) => {
                            return <TouchableOpacity
                                style={styles.flexItem}
                                key={index}
                                onPress={() => {
                                    MoengageUtils.trackMoengageEvents('econsult_selection_type')
                                    Redux.updateReduxQuestionList([]);
                                    Redux.updateReduxAnswerList([]);
                                    Redux.updateReduxCurrentQuestion({});
                                    Redux.updateReduxCurrentAnswer({});
                                    Redux.updateReduxImageList({});
                                    Redux.updateConsultationParam({
                                        selectedMember: memberData,
                                        selectedCategory: caseObject
                                    });
                                    setTimeout(() => {
                                        props.navigation.navigate(ScreenRoute.questionaire_screen)
                                    }, 200);
                                }
                                }><View style={[AppStyles.lightShadow, { borderRadius: 8 }]}>
                                    <Image resizeMode={categoriesCarrierList.length - 1 === index ? 'contain' : 'cover'} source={{
                                        uri: CommonUtils.checkOSPlatform(caseObject),
                                        width: AppTheme.appWidth / 2 - 32,
                                        height: AppTheme.appWidth / 2 - 32,
                                    }} style={{
                                        borderTopRightRadius: 8, borderTopLeftRadius: 8, resizeMode: 'cover'
                                    }} />
                                    <Text style={styles.categoryTxt}
                                    >{caseObject.cm.en}</Text></View></TouchableOpacity>
                        })
                    }
                </View>

            </ScrollView>

        </View>

    )
}

export default CategorySelection;

const styles = StyleSheet.create(addFontFamilyStyle({
    inputBox: {
        marginLeft: 16,
        width: AppTheme.appWidth - 50,
        height: 44,
        fontSize: 16,
        fontWeight: '400',
        padding: 8
    },
    searchInput: {
        height: 54,
        flexDirection: "row",
        borderWidth: 1,
        borderRadius: 4,
        justifyContent: "center",
        alignContent: "center",
        textAlign: "center",
        shadowColor: AppTheme.color.black,
        zIndex: 1, shadowOpacity: 0.3, shadowRadius: 5, shadowOffset: {
            height: 1.4,
            width: 1.4
        }
    },
    searchIcon: {
        paddingLeft: 10,
        paddingRight: 12,
        paddingTop: 5,
        lineHeight: 30
    },
    flexContainer: {
        // width: '100%',
        zIndex: 9,
        margin: 'auto',
        flex: 1,
        flexDirection: 'row',
        flexWrap: 'wrap',
        // justifyContent: 'space-evenly',
        // alignItems: 'flex-start' // if you want to fill rows left to right
        marginLeft: 4,

    },
    flexItem: {
        // width: ((AppTheme.appWidth / 2) - 32), // is 50% of container width
        // height: 170,
        // marginVertical: 5,
        margin: 8,
        borderRadius: 4
    },
    categoryTxt: {
        marginVertical: 8, alignItems: "center",
        textAlign: "center", width: AppTheme.appWidth / 2 - 32
    }
}))